import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, connect } from "react-redux";
import { arrayOf, shape, string, bool } from "prop-types";
import { push } from "connected-react-router";

import ArrowBack from "pages/_components/header/components/ArrowBack";
import Button from "pages/_components/Button";
import I18n from "pages/_components/I18n";
import Image from "pages/_components/Image";
import MainContainer from "pages/_components/MainContainer";
import Container from "pages/_components/Container";
import { Col, Row } from "react-bootstrap";
import { selectors as environmentSelectors } from "reducers/environment";
import Drawer from "pages/_components/Drawer/Drawer";
import { availableStepsAndPages } from "pages/desktop/utils";
import { backDefaultProps } from "../customProductHead";

const Back = ({ className, backLinkTo, onBack, currentStepRequest, showLabel }) => {
    const dispatch = useDispatch();
    const [boolWelcome, setBoolWelcome] = useState(false);
    const [backBool, setBool] = useState(false);
    let datos = window.location.href.split("/").length;
    const validate = window.location.href.split("/")[datos - 2] ?? null;
    datos = window.location.href.split("/")[datos - 1] ?? null;
    const goBack = () => {
        if (validate !== null && validate !== undefined && validate === "environment") {
            let pageNow = availableStepsAndPages.findIndex((x) => x === datos);
            pageNow = pageNow > 0 ? pageNow - 1 : pageNow;
            dispatch(push(`/environment/${availableStepsAndPages[pageNow ?? 0] ?? "stepStart"}`));
            return;
        }
        onBack();
    };
    useEffect(() => {
        if (currentStepRequest.status === "SUCCESS") {
            if (currentStepRequest?.value?.currentStep) {
                if (currentStepRequest?.value?.currentStep === datos) {
                    setBoolWelcome(true);
                }
            }
        }
    }, [currentStepRequest]);
    return (
        <>
            <div className="toolbar-view-back">
                <ArrowBack backLinkTo={backLinkTo} onClickBack={onBack} showLabel={showLabel} className={className} />
            </div>
            {/*
            {backLinkTo && (
                <div className={`toolbar-item toolbar-view-back ${className}`}>
                    <Link className="btn btn-link toolbar-btn view-back" to={backLinkTo}>
                        <Image className="svg-icon" src="images/figma/icon/arrow-left.svg" />
                        <I18n id="global.back" componentProps={{ className: "visually-hidden" }} />
                    </Link>
                </div>
            )}
            {onBack && (
                <div className={`toolbar-item toolbar-view-back ${className}`}>
                    <Button
                        className="btn toolbar-btn view-back"
                        onClick={() => {
                            setBool(true);
                        }}
                        image="images/figma/icon/arrow-left.svg"
                        block={false}
                        label="global.back"
                        bsStyle="link toolbar-btn view-back"
                    />
                </div>
            )} */}
            <Drawer
                className="qr-slider"
                openSidebar={backBool}
                toggleSidebar={() => {
                    setBool(false);
                }}>
                <div className="container full-width">
                    <h2 className="title-content">
                        <MainContainer className="main-container onboarding-layout">
                            <div className="above-the-fold">
                                <Container className="flex-grow items-center container--layout">
                                    <Col className="col-12" style={{ marginTop: "30%" }}>
                                        <figure className="justify-center flex">
                                            <Image src="images/figma/illustrations/onboarding10.svg" />
                                        </figure>
                                        <div className="media-object media-object--state-error">
                                            <div className="media-object--text">
                                                <I18n
                                                    id=""
                                                    defaultValue="¿Estas seguro que querés abandonar la operacion?"
                                                    component="h2"
                                                />
                                                <I18n
                                                    id=""
                                                    defaultValue="Si abandonas la operación, perderás los datos ingresados al retonar a la misma."
                                                    component="h6"
                                                />
                                            </div>
                                        </div>
                                    </Col>
                                    <Row>
                                        <Col className="col-6">
                                            <Button
                                                bsStyle="primary"
                                                label="global.ok"
                                                onClick={goBack}
                                                defaultLabelText="Aceptar"
                                                block
                                            />
                                        </Col>
                                        <Col className="col-6">
                                            <Button
                                                bsStyle="outline"
                                                label="global.ok"
                                                onClick={() => {
                                                    setBool(false);
                                                }}
                                                defaultLabelText="Cancelar"
                                                block
                                            />
                                        </Col>
                                    </Row>
                                </Container>
                                {/* <Container className="flex-grow items-center container--layout"></Container> */}
                            </div>
                        </MainContainer>
                    </h2>
                    <div className="row" />
                </div>
            </Drawer>

            <Drawer
                className="qr-slider"
                openSidebar={boolWelcome}
                toggleSidebar={() => {
                    setBoolWelcome(false);
                }}>
                <div className="container full-width">
                    <h2 className="title-content">
                        <MainContainer className="main-container onboarding-layout">
                            <div className="above-the-fold">
                                <Container className="flex-grow items-center container--layout">
                                    <Col className="col-12" style={{ marginTop: "30%" }}>
                                        <div className="media-object media-object--state-error">
                                            <div className="media-object--text">
                                                <I18n id="" defaultValue="¡Hola nuevamente!" component="h2" />
                                            </div>
                                        </div>

                                        <figure className="justify-center flex">
                                            <Image src="images/figma/illustrations/onboarding11.svg" />
                                        </figure>
                                        <div className="media-object media-object--state-error">
                                            <div className="media-object--text">
                                                <I18n
                                                    id=""
                                                    defaultValue="Vamos a retomar el proceso de alta de tu empresa justo donde lo dejaste."
                                                    component="h6"
                                                />
                                            </div>
                                        </div>
                                    </Col>
                                    <Row>
                                        <Col className="col-12">
                                            <Button
                                                bsStyle="primary"
                                                label="global.ok"
                                                onClick={() => {
                                                    setBoolWelcome(false);
                                                }}
                                                defaultLabelText="Continuar"
                                                block
                                            />
                                        </Col>
                                    </Row>
                                </Container>
                                {/* <Container className="flex-grow items-center container--layout"></Container> */}
                            </div>
                        </MainContainer>
                    </h2>
                </div>
            </Drawer>
        </>
    );
};

Back.propTypes = {
    className: string,
    backLinkTo: string,
    onBack: string,
    currentStepRequest: arrayOf(shape({})).isRequired,
    showLabel: bool,
};

Back.defaultProps = backDefaultProps;
const mapStateToProps = (state) => ({
    currentStepRequest: environmentSelectors.getCurrentStepRequest(state),
});

export default connect(mapStateToProps)(Back);
